<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a *ngIf="logo" class="logo" (click)="navigateHome()"
      ><img class="logo-img" [src]="logo" alt="logo"
    /></a>
  </div>
</div>

<div class="header-container">
  <nb-actions size="small">
    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
      <nb-user
        [nbContextMenu]="userMenu"
        [onlyPicture]="userPictureOnly"
        [name]="user?.email || projectName"
        [picture]="user?.photo"
      >
      </nb-user>
    </nb-action>
  </nb-actions>
</div>
